import { message } from 'antd'

const showError = (msg?: string | object, e?: any) => {
  let errorMsg = ''
  if (typeof msg !== 'string') {
    errorMsg = getErrorMessage(msg)
  } else {
    errorMsg = msg ? (msg + ' ') : ''
    errorMsg += getErrorMessage(e)
  }
  message.error(errorMsg)
}

const getErrorMessage = (e?: any): string => {
  if (!e) return ''
  const status = e?.response?.status || ''
  const { errors, messages, error } = e?.response?.data || {}
  let result: string = ''
  if (status) {
    result += '[' + status + '] '
  }
  if (errors?.length) {
    result += errors?.[0] || ''
    result += ' '
  }
  if (messages?.length) {
    result += messages?.[0] || ''
    result += ' '
  }
  if (error) {
    result += error
  }
  return result
}

export { showError }
